
import { Component, Prop, Vue, computed } from 'vue-property-decorator';
import { cva } from '@/utils/cva';

export interface SummaryStat {
  label: string;
  value: string;
}

// CVA tanımı
const ledgerSectionVariants = cva('rounded-lg', {
  variants: {
    variant: {
      default: '',
      elevated: 'elevation-1',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

/**
 * LedgerSection - Alacak kalemleri gösterimi için component
 * Shadcn UI tarzı, Vuetify 2 ile
 */
@Component
export default class LedgerSection extends Vue {
  @Prop({ type: String, required: true })
  title!: string;

  @Prop({ type: String, default: 'mdi-file-document-edit' })
  icon!: string;

  @Prop({ type: Boolean, default: true })
  iconSmall!: boolean;

  @Prop({ type: String, default: 'primary' })
  iconColor!: string;

  @Prop({ type: Array })
  items?: any[];

  @Prop({ type: Array })
  summary?: SummaryStat[];

  @Prop({ type: String })
  emptyMessage?: string;

  @Prop({ type: String, default: 'lg' })
  rounded!: string;

  @Prop({ type: String, default: 'default' })
  variant!: 'default' | 'elevated';

  @Prop({ type: String })
  className?: string;

  get cardClasses(): string {
    return ledgerSectionVariants({
      variant: this.variant,
      className: this.className,
    });
  }
}
